import { FeatureFlags } from "@/entities/config";
import { createContext, useContext } from "react";

export const FeatureFlagsContext = createContext<FeatureFlags | undefined>(undefined);

export function useFeatureFlagValue<T extends keyof FeatureFlags>(name: T, defaultValue: FeatureFlags[T]): FeatureFlags[T] {
    const context = useContext(FeatureFlagsContext);
    if (!context) {
        return defaultValue;
    }
    return context[name];
}
